import ENTITIES from '..';
import { updateRemote } from '../atomic';
import GAME_STRUCT, { GAME_STATUS } from '.';
import { connection } from '../../..';

export function startGame(store, game) {
  updateRemote(store, ENTITIES.GAME, {
    [GAME_STRUCT.ID]: game[GAME_STRUCT.ID],
    [GAME_STRUCT.EXERCISE_ID]: game[GAME_STRUCT.EXERCISE_ID],
    [GAME_STRUCT.STATUS_ID]: GAME_STATUS.PLAYING,
  });
}

export function finishGame(store, game) {
  updateRemote(store, ENTITIES.GAME, {
    [GAME_STRUCT.ID]: game[GAME_STRUCT.ID],
    [GAME_STRUCT.EXERCISE_ID]: game[GAME_STRUCT.EXERCISE_ID],
    [GAME_STRUCT.STATUS_ID]: GAME_STATUS.FINISHED,
  });
}

export function editGame(store, game) {
  updateRemote(store, ENTITIES.GAME, game);
}

export function deleteGame(store, game) {
  updateRemote(store, ENTITIES.GAME, {
    [GAME_STRUCT.ID]: game[GAME_STRUCT.ID],
    [GAME_STRUCT.EXERCISE_ID]: game[GAME_STRUCT.EXERCISE_ID],
    [GAME_STRUCT.HIDDEN]: 1,
  });
}

export function exportFile(store, data) {
  connection.exportFile(data);
}

export function uploadFile(store, file) {
  connection.uploadFile(file);
}

export function sendGamePins(store, game) {
  const siteUrl = document.location.href;
  connection.sendGamePins(game[GAME_STRUCT.ID], siteUrl);
}
